import { Avatar, Box, Button, Typography } from '@mui/material';
import React from 'react';

const AboutUs = () => {
  return (
    <div className="flex gap-28 m-auto justify-center
     w-11/12 items-center py-24 md:flex-row flex-col">

<Box className="relative">
  {/* Background Border Box */}
  <Box 
    className="absolute -top-3 left-40 w-3/4 h-full 
    border-2 border-[#E9DDDD] rounded-3xl hidden md:block"
  />

<Box 
sx={{
  width: { md:"115%",xl: '100%', }, // Responsive width
}}
className="relative w-full h-auto z-10 mt-4">
  {/* Main Image */}
  <Box 
  
    component="img" 
    src="aboutus1.svg" 
    alt="About Us" 
    className="w-full h-auto"
  />

  {/* Top-left overlay container (white background) */}
  <Box 
    className="absolute top-4 left-4 md:top-2 md:left-2
    
     w-16 h-16 md:w-17 md:h-17 bg-white
     rounded-lg flex items-center justify-center shadow-md"
  >
    {/* Overlay Image */}
    <Box 
      component="img" 
      src="/logo2.svg"  // Replace with your overlay image path
      alt="Overlay" 
      className="w-10 h-10 md:w-12 md:h-12"
    />
  </Box>
</Box>



  {/* Floating Box with Avatars */}
  <Box 
    className="absolute -bottom-10 -right-14 w-3/4 h-20 border-2 border-[#E9DDDD] rounded-xl 
    z-20 bg-white flex items-center justify-center gap-6 text-white shadow-lg"
    sx={{
      width: { xs: '90%', xl: '75%', md:"100%" }, // Responsive width
      right: { xs: '5%', md: '-3.5rem' }, // Adjust position on small screens
      bottom: { xs: '-2.5rem', md: '-6rem' ,xl:'-2.5rem' }, // Prevent overlap on mobile
      height: { xs: 'auto', xl: '80px' }, // Adjust height
      padding: { xs: 2, xl: 0 }, // Padding for small screens
      
      flexWrap: { xs: 'wrap', xl: 'nowrap' } // Stack on mobile
    }}
  >
    {/* Avatars Section */}
    <Box className="flex items-center ">
      <Avatar 
        alt="Remy Sharp" 
        src="/avatar1.svg" 
        className="w-12 h-12 border-2 border-white shadow-lg" 
      />
      <Avatar 
        alt="Travis Howard" 
        src="/avatar2.svg" 
        className="w-12 h-12 border-2 border-white shadow-lg -ml-2" 
      />
      <Avatar 
        alt="Cindy Baker" 
        src="/avatar3.svg" 
        className="w-12 h-12 border-2 border-white shadow-lg -ml-2" 
      />
      
      {/* More Users Avatar */}
      <Box className="relative w-12 h-12 -ml-2 border-2 border-white rounded-full">
        <Avatar 
          alt="More Users" 
          src="/static/images/avatar/3.jpg" 
          className="w-12 h-12 border-2 border-white shadow-lg top-1 blur-sm"
        />
        <Box 
          className="absolute inset-0 right-2 flex items-center 
          justify-center text-[#798194] font-bold text-xs z-10"
        >
          &gt;5.0K
        </Box>
      </Box>
    </Box>

    {/* Text Section */}
    <Box className="text-black text-center md:text-left">
      More than 5000 professionals already joined
    </Box>
  </Box>
</Box>


      

        <Box sx={{ maxWidth: '60%'  }}>
            <Typography variant="h5" gutterBottom sx={{ color: '#1F212D', fontWeight: 600, mb: 2 }}>
            About Us
            </Typography>
            <Typography variant="body1" sx={{ color: '#70758D', lineHeight: 1.6 }}>
            Our platform simplifies the workday for healthcare professionals by
          streamlining collaboration, improving workflows, and providing easy
          access to learning resources. With features like seamless shift swaps,
          instant communication, and a shared knowledge space, we help you work
          smarter, so you can focus on delivering excellent patient care.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              sx={{
                mt: 4,
                padding: '12px 24px',
                background: 'linear-gradient(to right, #534DF4, #AA58F2)',
                '&:hover': {
                  background: 'linear-gradient(to right, #AA58F2, #534DF4)',
                },
              }}
            >
              Read More
            </Button>
          </Box>
       
      </div>
   
  );
};

export default AboutUs;
